import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpParams, HttpParamsOptions, HttpHeaders } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { retry, catchError } from 'rxjs/operators';

import { environment } from '@env/environment';

import { map, tap } from 'rxjs/operators';

import { SortDirection } from '@angular/material/sort';

import { AuthQuery } from '@app/auth/auth.query';

/*
const HttpUploadOptions = {
  headers: new HttpHeaders({
    'Content-Type': 'application/json',
    'Access-Control-Allow-Origin': '*',
    'Access-Control-Allow-Headers': '*',
  }),
};
*/

export interface JournalEntityIds {
  kunde_id?: string;
  standort_id?: string;
  kontrolltermin_id?: string;
  kontrollindikator_id?: string;
  kontakt_id?: string;
  techniker_id?: string;
  mitarbeiter_id?: string;
  indikator_id?: number;
}

export interface Journal {
  journalid?: number;
  userid: string;
  user_vorname?: string;
  user_nachname?: string;
  dienstnr: null;
  dienstnr_stvo: null;
  created: Date;
  aktion: string;
  info: null;
  category: null;
  aktenzeichen: null;
  image: null;
  longitude: null;
  latitude: null;
  dienstname: string | null;
  mobile_id: null;
  gemeinde_id: null;
  kunde_id?: string;
  standort_id?: string;
  standort_name?: string;
  kontrolltermin_id?: string;
  kontrolltermin_nummer?: number | string;
  kontrollindikator_id?: string;
  kontakt_id?: string;
  techniker_id?: string;
  mitarbeiter_id?: string;
  indikator_id?: number;
  source?: string;
}

export interface JournalSingle {
  data: Journal;
  page: number;
  per_page: number;
  total: number;
  total_pages: number;
}

export interface JournalTable {
  data: Journal[];
  page: number;
  per_page: number;
  total: number;
  total_pages: number;
}

const httpOptions = {
  headers: new HttpHeaders({
    'Content-Type': 'application/json',
    // 'Access-Control-Allow-Headers': '*',
    'Access-Control-Allow-Origin': '*',
  }),
};

//
// --------------------------------------------------------------
//

@Injectable({
  providedIn: 'root',
})
export class JournalService {
  errorMsg: string = '';

  constructor(private httpClient: HttpClient, private authQuery: AuthQuery) {}

  /**
   * GET ALL
   *
   * @return response()
   */

  public getAll(
    pageNumber: Number,
    pageSize: Number,
    sort: string,
    order: SortDirection,
    searchTerm: string,
    filtersArgs: string,
    filters?: {
      kunde_id?: string;
      standort_id?: string;
      kontrolltermin_id?: string;
      kontrollindikator_id?: string;
      kontakt_id?: string;
      techniker_id?: string;
      mitarbeiter_id?: string;
      indikator_id?: number;
      source?: string;
      action_type?: string;
      date_from?: string;
      date_to?: string;
      userid?: string;
    }
  ): Observable<JournalTable> {
    const apiUrl = `${environment.apiUrl}/journal`;
    // '?page=${pageNumber}&per_page=${pageSize}&sort=${sort}&sorder=${order}`

    return this.httpClient.get<JournalTable>(apiUrl, {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        // 'Access-Control-Allow-Headers': '*',
        'Access-Control-Allow-Origin': '*',
      }),
      params: (() => {
        let params = new HttpParams()
          .set('page', '' + pageNumber)
          .set('per_page', '' + pageSize)
          .set('sort', sort)
          .set('sorder', order)
          .set('sterm', searchTerm)
          .set('filters', filtersArgs)
          .set('webapp', 1);
        
        // Add entity ID filters if provided
        if (filters) {
          if (filters.kunde_id) params = params.set('kunde_id', filters.kunde_id);
          if (filters.standort_id) params = params.set('standort_id', filters.standort_id);
          if (filters.kontrolltermin_id) params = params.set('kontrolltermin_id', filters.kontrolltermin_id);
          if (filters.kontrollindikator_id) params = params.set('kontrollindikator_id', filters.kontrollindikator_id);
          if (filters.kontakt_id) params = params.set('kontakt_id', filters.kontakt_id);
          if (filters.techniker_id) params = params.set('techniker_id', filters.techniker_id);
          if (filters.mitarbeiter_id) params = params.set('mitarbeiter_id', filters.mitarbeiter_id);
          if (filters.indikator_id) params = params.set('indikator_id', '' + filters.indikator_id);
          if (filters.source) params = params.set('source', filters.source);
          if (filters.action_type) params = params.set('action_type', filters.action_type);
          if (filters.date_from) params = params.set('date_from', filters.date_from);
          if (filters.date_to) params = params.set('date_to', filters.date_to);
          if (filters.userid) params = params.set('userid', filters.userid);
        }
        return params;
      })(),
    });
  }

  /**
   * GET / FIND BY ID
   *
   * @return response()
   */
  getItemById(id: number): Observable<JournalSingle> {
    const apiUrl = `${environment.apiUrl}/journal/` + id;

    return this.httpClient
      .get<JournalSingle>(apiUrl, {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          // 'Access-Control-Allow-Headers': '*',
          'Access-Control-Allow-Origin': '*',
        }),
        params: new HttpParams().set('id', '' + id),
      })
      .pipe(
        map((response: JournalSingle) => {
          return {
            ...response,
          };
        })
      );
  }

  /**
   * GET / FIND BY FILTER
   *
   * @return response()
   */
  getItemsByParams(data: any): Observable<any> {
    const headers = new HttpHeaders().set('Content-Type', 'application/json');

    /*
      const data: any = {
        this: 'thisThing',
        that: 'thatThing',
        other: 'otherThing'
      };
     */

    const httpParams: HttpParamsOptions = { fromObject: data } as HttpParamsOptions;

    const options = { params: new HttpParams(httpParams), headers: headers };

    return this.httpClient.get<Journal[]>(environment.apiUrl + '/journalby', options).pipe(
      tap((resp) => {
        //this.repo.setQuizes( resp || []);
        return resp;
      }),
      catchError((error) => {
        let errorMsg: string = '';
        if (error.error instanceof ErrorEvent) {
          this.errorMsg = `Error: ${error.error.message}`;
        } else {
          this.errorMsg = this.getServerErrorMessage(error);
        }

        return throwError(errorMsg);
      })
    );
  }

  /**
   * Extract entity IDs from common data structures
   * Only extracts IDs that are explicitly present - no generic fallbacks to avoid incorrect assignments
   */
  extractEntityIds(data: any): JournalEntityIds {
    if (!data) {
      return {};
    }
    
    // Helper to check if data represents a specific entity type based on characteristic fields
    const hasKundeFields = data.suchbegriff !== undefined || (data.name && data.uuid);
    const hasStandortFields = data.nummer !== undefined && data.name !== undefined;
    const hasKontrollterminFields = data.einsatznummer !== undefined || data.datum_durchfuerung !== undefined;
    const hasKontrollindikatorFields = data.befall_ampel !== undefined || (data.indikator_id && !hasKontrollterminFields);
    
    return {
      // For kunde_id: check explicit fields, nested kunde object, or if data itself is a kunde
      kunde_id: data.kunde_id || data.kunde?.id || data.kunde?.uuid || (hasKundeFields && (data.uuid || data.id)) || undefined,
      // For standort_id: check explicit fields, nested standort object, or if data itself is a standort
      standort_id: data.standort_id || data.standort?.id || (hasStandortFields && data.id) || undefined,
      // Only extract kontrolltermin_id if explicitly present or if data is clearly a kontrolltermin
      kontrolltermin_id: data.kontrolltermin_id || data.kontrolltermin?.id || (hasKontrollterminFields && data.id) || undefined,
      // Only extract kontrollindikator_id if explicitly present or if data is clearly a kontrollindikator
      kontrollindikator_id: data.kontrollindikator_id || data.kontrollindikator?.id || (hasKontrollindikatorFields && data.id) || undefined,
      kontakt_id: data.kontakt_id || data.kontakt?.id || undefined,
      techniker_id: data.techniker_id || data.techniker?.id || undefined,
      mitarbeiter_id: data.mitarbeiter_id || data.mitarbeiter?.id || undefined,
      indikator_id: data.indikator_id || data.indikator?.id || undefined
    };
  }

  /**
   * CREATE
   *
   * @return response()
   */
  log(
    aktion: string,
    aktenzeichen: string,
    info: string,
    entityIds?: JournalEntityIds,
    level: 'default' | 'extended' = 'default'
  ): void {
    var data: any = {
      uid: '' + this.authQuery.userid,
      aktion: aktion,
      aktenzeichen: aktenzeichen,
      info: info,
      source: 'webapp',
      level: level === 'extended' ? 'extended' : 'default',
    };
    
    // Add entity IDs if provided
    if (entityIds) {
      data.entityIds = entityIds;
    }
    console.log('write-to-lot ' + aktion);

    this.httpClient
      .post<any>(environment.apiUrl + '/journal', JSON.stringify(data), httpOptions)
      .pipe(
        map((response) => {
          return {
            ...response.data,
            //id: response.data.quuid,
            //quizdata: '',
          };
        }),
        tap((response: any) => {
          console.log(response);
          //this.repo.addQuiz(response);
        }),
        catchError((error) => {
          let errorMsg: string = '';
          if (error.error instanceof ErrorEvent) {
            this.errorMsg = `Error: ${error.error.message}`;
          } else {
            this.errorMsg = this.getServerErrorMessage(error);
          }

          return throwError(errorMsg);
        })
      )
      .subscribe({
        next: (response) => {
          console.log('Server response:', response);
          return response;
          // Display the response in your component's template
          // or handle it as needed
        },
        error: (error) => {
          console.error('Error:', error);
          this.errorMsg = error;
          // Handle or display the error message in your component's template
        },
      });
  }

  /**
   * Write code on Method
   *
   * @return response()
   */
  private getServerErrorMessage(error: HttpErrorResponse) {
    console.log('custom service error handler');

    switch (error.status) {
      case 0: {
        // A client-side or network error occurred. Handle it accordingly.
        //console.error('An error occurred:', error.error);
        return `An error occurred: ${error.error}`;
      }
      case 404: {
        return `Not Found: ${error.message}`;
      }
      case 403: {
        return `Access Denied: ${error.message}`;
      }
      case 500: {
        return `Internal Server Error: ${error.message}`;
      }
      default: {
        return `Unknown Server Error: ${error.error}`;
      }

      // Return an observable with a user-facing error message.
      //return throwError(() => new Error('Something bad happened; please try again later.'));
    }
  }
}
